module.exports = __webpack_public_path__ + "static/media/04.1b176780.mp3";